import css from './PageContent.module.scss'

const PageContent = ({ children }) => <div className={css.Page}>{children}</div>

export default PageContent
